// extracted by mini-css-extract-plugin
module.exports = {"btn":"BetonExpenseDetailsBtn_btn__3JuDq","define":"BetonExpenseDetailsBtn_define__G4gjl"};